export const starSpawner = () => {
  const starSrc = "./assets/images/star.svg";

  // Create a container for the stars to avoid polluting the DOM too much
  const container = document.createElement("div");
  Object.assign(container.style, {
    position: "fixed",
    top: "0",
    left: "0",
    width: "100svw",
    height: "100svh",
    pointerEvents: "none",
    zIndex: "9999",
    overflow: "hidden",
    background: "transparent",
  });
  document.body.appendChild(container);

  // Function to create and animate a single star
  function createStar(x, y) {
    const star = document.createElement("img");
    star.src = starSrc;
    star.alt = "";

    // Determine size based on device width (using 768px as breakpoint)
    const isMobile = window.innerWidth < 768;
    const size = isMobile ? "2.4rem" : "6rem";

    const offsetX = (Math.random() - 0.5) * 50;
    const offsetY = (Math.random() - 0.5) * 50;

    Object.assign(star.style, {
      position: "absolute",
      left: `${x + offsetX}px`,
      top: `${y + offsetY}px`,
      width: size,
      height: size,
      opacity: "0",
      transform: "translate(-50%, -50%) scale(0)",
      pointerEvents: "none",
      willChange: "transform, opacity",
    });

    container.appendChild(star);

    // Animation values
    // const rotate = (Math.random() - 0.5) * 720;

    const duration = Math.random() * 2000 + 3000;

    // Web Animations API
    const animation = star.animate(
      [
        {
          opacity: 0,
          transform: "translate(-50%, -50%) scale(0.5)",
          offset: 0
        },
        {
          opacity: 1,
          transform: "translate(-50%, -50%) scale(1)",
          offset: 0.25
        },
        {
          opacity: 0,
          transform: "translate(-50%, -50%) scale(0.8)",
          offset: 0.5
        },
        {
          opacity: 1,
          transform: "translate(-50%, -50%) scale(1)",
          offset: 0.75
        },
        {
          opacity: 0,
          transform: "translate(-50%, -50%) scale(0.5)",
          offset: 1
        },
      ],
      {
        duration: duration,
        easing: "cubic-bezier(0.25, 0.1, 0.25, 1)",
        fill: "forwards",
      }
    );

    // Track this star
    const starId = Date.now() + Math.random();
    activeStars.push({ id: starId, x, y });

    animation.onfinish = () => {
      star.remove();
      // Remove from active tracking
      const index = activeStars.findIndex(s => s.id === starId);
      if (index > -1) {
        activeStars.splice(index, 1);
      }
      // Respawn to maintain population
      scheduleSpawn();
    };
  }

  // State
  const activeStars = [];
  const minDistance = 150;
  const maxStars = 6;

  function scheduleSpawn() {
    if (document.hidden) {
      setTimeout(scheduleSpawn, 1000);
      return;
    }

    if (activeStars.length < maxStars) {
      setTimeout(() => {
        attemptSpawn();
      }, Math.random() * 2000 + 500);
    }
  }

  function attemptSpawn() {
    if (activeStars.length >= maxStars) return;

    let x, y, valid = false;
    let attempts = 0;

    while (!valid && attempts < 15) {
      x = Math.random() * window.innerWidth;
      y = Math.random() * window.innerHeight;
      valid = true;

      // Check exclusion zones (Speaker Section)
      const speakerSection = document.getElementById("speaker");
      if (speakerSection) {
        const rect = speakerSection.getBoundingClientRect();
        // Check if x,y is inside the speaker section
        if (
          x >= rect.left &&
          x <= rect.right &&
          y >= rect.top &&
          y <= rect.bottom
        ) {
          valid = false;
        }
      }

      if (valid) {
        for (const s of activeStars) {
          const dx = x - s.x;
          const dy = y - s.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < minDistance) {
            valid = false;
            break;
          }
        }
      }
      attempts++;
    }

    if (valid) {
      createStar(x, y);
    } else {
      setTimeout(scheduleSpawn, 100);
    }
  }

  // Initial population
  for (let i = 0; i < maxStars; i++) {
    scheduleSpawn();
  }
};
